import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "store/features/auth/authSlice";
import { toast } from "sonner";
import Breadcrumb from "components/Common/Breadcrumb";
import DashboardLoader from "components/Loader/DashboardLoader";
import {
  useGetProjectByIdQuery,
  useGetClientQuery,
  useUpdateProjectMutation
} from "store/features/client/clientManagementApi";
import logoImg from "../../assets/images/logo-sm.png";
import { useCreateMoneyReceiptMutation } from "store/features/invoice/moneyReceiptApi";

const MoneyReceipt = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const receiptRef = useRef(null);

  const { data: project, isLoading: projectLoading } = useGetProjectByIdQuery(projectId);
  const { data: client, isLoading: clientLoading } = useGetClientQuery(project?.client, {
    skip: !project?.client,
  });

  const [isSending, setIsSending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currency, setCurrency] = useState("BDT"); // Add this line

  const [createMoneyReceipt] = useCreateMoneyReceiptMutation();
  const [updateProject] = useUpdateProjectMutation();

  // Editable receipt state
  const [receiptData, setReceiptData] = useState({
    // Company Info
    companyHeadOffice: "950 Hillcrest Rd, Saint John, NB E2N2B2, Canada",
    companyBangladeshOffice: "House-752, Road-8, Adabor, Dhaka",
    companyPhoneBD: "+880 1636-131313",
    companyPhoneCanada: "+1 (506) 899-3939",
    companyEmail: "support@qwikit.ca",
    companyWebsite: "www.qwikit.ca",

    // Client Info (Received From)
    clientName: "",
    clientAddress: "",
    clientPhone: "",
    clientEmail: "",

    // Receipt Details
    receiptNo: "",
    receiptDate: new Date().toISOString().split("T")[0],

    // Payment Details
    // totalAmount: 0,
    // receivedAmount: 0,
    // remainingAmount: 0,
    // paymentMethod: "Bank Transfer",
    // paymentStatus: "PLEASE COMPLETE THE PENDING PAYMENT",


    // Payment Details
    totalAmount: 0,
    newReceivedAmount: 0,        // ✅ NEW - User enters today's payment
    totalReceivedAmount: 0,      // ✅ NEW - Auto calculated (old total + new)
    remainingAmount: 0,
    paymentMethod: "Bank Transfer",
    paymentStatus: "PLEASE COMPLETE THE PENDING PAYMENT",
    currency: "BDT",

    // Footer
    footerText: "Thank you for your payment! We appreciate your trust in Qwik IT Services",
  });

  // Payment methods options
  const paymentMethods = ["Bank Transfer", "bKash", "Nagad", "Stripe", "Cash"];

  // Load project data into receipt
  // useEffect(() => {
  //   if (project && client) {
  //     // Calculate total from project budget
  //     const projectBudget = parseFloat(project.budget) || 0;

  //     // Calculate total received from payments
  //     const totalReceived = (project.payment || []).reduce(
  //       (sum, payment) => sum + (parseFloat(payment.amount) || 0),
  //       0
  //     );

  //     const remainingAmount = projectBudget - totalReceived;

  //     // Determine payment status
  //     let paymentStatus = "PENDING";
  //     if (totalReceived === 0) {
  //       paymentStatus = "PENDING";
  //     } else if (totalReceived >= projectBudget) {
  //       paymentStatus = "PAID IN FULL";
  //     } else {
  //       paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
  //     }

  //     // Get client email from client data
  //     const clientEmail = client.client_email || client.email || "";

  //     // Set receipt data with client info
  //     setReceiptData((prev) => ({
  //       ...prev,
  //       // Client Info
  //       clientName: client.company_name || client.client_name || "",
  //       clientAddress: client.address || "",
  //       clientPhone: client.contact_number || "",
  //       clientEmail: clientEmail,

  //       // Receipt details
  //       receiptNo: `QIT-REC-${project.id}-${Date.now().toString().slice(-6)}`,
  //       receiptDate: new Date().toISOString().split("T")[0],

  //       // Payment details
  //       totalAmount: projectBudget,
  //       receivedAmount: totalReceived,
  //       remainingAmount: remainingAmount,
  //       paymentStatus: paymentStatus,
  //     }));
  //   }
  // }, [project, client]);

  // Load project data into receipt
  useEffect(() => {
    if (project && client) {
      // Calculate total from project budget
      const projectBudget = parseFloat(project.budget) || 0;

      // Calculate total received from payments (OLD payments sum)
      const totalReceivedFromPayments = (project.payment || []).reduce(
        (sum, payment) => sum + (parseFloat(payment.amount) || 0),
        0
      );

      const remainingAmount = projectBudget - totalReceivedFromPayments;

      // Determine payment status
      let paymentStatus = "PENDING";
      if (totalReceivedFromPayments === 0) {
        paymentStatus = "PENDING";
      } else if (totalReceivedFromPayments >= projectBudget) {
        paymentStatus = "PAID IN FULL";
      } else {
        paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
      }

      // Get client email from client data
      const clientEmail = client.client_email || client.email || "";

      // Set receipt data with client info
      setReceiptData((prev) => ({
        ...prev,
        // Client Info
        clientName: client.company_name || client.client_name || "",
        clientAddress: client.address || "",
        clientPhone: client.contact_number || "",
        clientEmail: clientEmail,

        // Receipt details
        receiptNo: `QIT-REC-${project.id}-${Date.now().toString().slice(-6)}`,
        receiptDate: new Date().toISOString().split("T")[0],

        // Payment details
        totalAmount: projectBudget,
        newReceivedAmount: 0,                              // ✅ Start at 0
        totalReceivedAmount: totalReceivedFromPayments,    // ✅ Show existing total
        remainingAmount: remainingAmount,
        paymentStatus: paymentStatus,
      }));
    }
  }, [project, client]);

  // Update remaining amount when received amount changes
  // useEffect(() => {
  //   const remaining = receiptData.totalAmount - receiptData.receivedAmount;
  //   let paymentStatus = "PENDING";
  //   if (receiptData.receivedAmount === 0) {
  //     paymentStatus = "PENDING";
  //   } else if (receiptData.receivedAmount >= receiptData.totalAmount) {
  //     paymentStatus = "PAID IN FULL";
  //   } else {
  //     paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
  //   }

  //   setReceiptData((prev) => ({
  //     ...prev,
  //     remainingAmount: remaining,
  //     paymentStatus: paymentStatus,
  //   }));
  // }, [receiptData.receivedAmount, receiptData.totalAmount]);

  // Update calculations when newReceivedAmount changes
  // Store original total received amount
  const originalTotalReceivedRef = useRef(0);

  // Load project data into receipt
  useEffect(() => {
    if (project && client) {
      // Calculate total from project budget
      const projectBudget = parseFloat(project.budget) || 0;

      // Calculate total received from payments (OLD payments sum)
      const totalReceivedFromPayments = (project.payment || []).reduce(
        (sum, payment) => sum + (parseFloat(payment.amount) || 0),
        0
      );

      // Store the original total received amount
      originalTotalReceivedRef.current = totalReceivedFromPayments;

      const remainingAmount = projectBudget - totalReceivedFromPayments;

      // Determine payment status
      let paymentStatus = "PENDING";
      if (totalReceivedFromPayments === 0) {
        paymentStatus = "PENDING";
      } else if (totalReceivedFromPayments >= projectBudget) {
        paymentStatus = "PAID IN FULL";
      } else {
        paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
      }

      // Get client email from client data
      const clientEmail = client.client_email || client.email || "";

      // Set receipt data with client info
      setReceiptData((prev) => ({
        ...prev,
        // Client Info
        clientName: client.company_name || client.client_name || "",
        clientAddress: client.address || "",
        clientPhone: client.contact_number || "",
        clientEmail: clientEmail,

        // Receipt details
        receiptNo: `QIT-REC-${project.id}-${Date.now().toString().slice(-6)}`,
        receiptDate: new Date().toISOString().split("T")[0],

        // Payment details
        totalAmount: projectBudget,
        newReceivedAmount: 0,
        totalReceivedAmount: totalReceivedFromPayments,
        remainingAmount: remainingAmount,
        paymentStatus: paymentStatus,
      }));
    }
  }, [project, client]);

  // Update calculations when newReceivedAmount changes
  useEffect(() => {
    const newPayment = receiptData.newReceivedAmount || 0;

    // Use the original total from the ref, not the state value
    const baseTotalReceived = originalTotalReceivedRef.current;

    // Calculate new total received (base + new payment)
    const newTotalReceived = baseTotalReceived + newPayment;

    // Calculate remaining amount
    const remaining = receiptData.totalAmount - newTotalReceived;

    // Determine payment status
    let paymentStatus = "PENDING";
    if (newTotalReceived === 0) {
      paymentStatus = "PENDING";
    } else if (newTotalReceived >= receiptData.totalAmount) {
      paymentStatus = "PAID IN FULL";
    } else {
      paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
    }

    setReceiptData((prev) => ({
      ...prev,
      totalReceivedAmount: newTotalReceived,
      remainingAmount: remaining,
      paymentStatus: paymentStatus,
    }));
  }, [receiptData.newReceivedAmount, receiptData.totalAmount]); // ✅ Removed totalReceivedAmount dependency


  // Format currency
  // const formatCurrency = (amount) => {
  //   return `BDT ${Math.round(amount).toLocaleString()}`;
  // };

  // Format currency with selected currency code
  const formatCurrency = (amount, currencyCode = null) => {
    const useCurrency = currencyCode || receiptData.currency || currency || "BDT";
    const formattedAmount = Math.round(amount).toLocaleString();

    switch (useCurrency) {
      case "USD":
        return `USD ${formattedAmount}`;
      case "CAD":
        return `CAD ${formattedAmount}`;
      case "EURO":
        return `EURO ${formattedAmount}`;
      case "BDT":
        return `BDT ${formattedAmount}`;
      default:
        return `BDT ${formattedAmount}`;
    }
  };


  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // Handle receipt field changes
  const handleReceiptChange = (field, value) => {
    setReceiptData((prev) => ({ ...prev, [field]: value }));
  };

  // Generate email HTML for money receipt
  //   const generateEmailHTML = () => {
  //     return `
  // <!DOCTYPE html>
  // <html>
  // <head>
  // <meta charset="UTF-8">
  // <title>Money Receipt</title>

  // <style>
  // @media only screen and (max-width:600px){

  //   .stack-column{
  //     display:block !important;
  //     width:100% !important;
  //     padding:0 !important;
  //     margin-bottom:8px !important;
  //   }

  //   .stack-center{
  //     display:block !important;
  //     width:100% !important;
  //     text-align:center !important;
  //     padding:0 !important;
  //     margin-bottom:10px;
  //   }

  //   .stack-left{
  //     display:block !important;
  //     width:100% !important;
  //     text-align:left !important;
  //     padding-top:10px !important;
  //   }

  // }
  // </style>

  // </head>

  // <body style="margin:0;padding:0;background:#eef2f7;font-family:Arial,sans-serif;">

  // <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
  // <tr>
  // <td align="center">

  // <!-- MAIN -->
  // <table width="100%" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

  // <!-- HEADER -->
  // <tr>
  // <td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">

  // <table width="100%">
  // <tr>

  // <!-- LOGO -->
  // <td class="stack-center" width="80" align="center">
  //   <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
  //        width="60"
  //        style="display:block;margin:0 auto;">
  // </td>

  // <!-- TITLE -->
  // <td class="stack-center">
  //   <h1 style="margin:0;font-size:24px;">MONEY RECEIPT</h1>
  //   <p style="margin:3px 0;font-size:12px;">Qwik IT Services</p>
  // </td>

  // <!-- RIGHT INFO -->
  // <td class="stack-left" align="right" style="font-size:12px;">
  //   <p><strong>Receipt No:</strong> ${receiptData.receiptNo}</p>
  //   <p><strong>Date:</strong> ${formatDate(receiptData.receiptDate)}</p>
  // </td>

  // </tr>
  // </table>

  // </td>
  // </tr>

  // <!-- CONTENT -->
  // <tr>
  // <td style="padding:20px;">

  // <!-- INFO GRID -->
  // <table width="100%">
  // <tr>

  // <td class="stack-column" width="50%" style="padding-right:10px;vertical-align:top;">
  // <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr>
  // <td style="padding:16px;">
  // <h3 style="margin:0 0 10px;color:#1e3a8a;">Received From</h3>
  // <p><strong>${receiptData.clientName || "-"}</strong></p>
  // <p>${receiptData.clientAddress || "-"}</p>
  // <p>${receiptData.clientPhone || "-"}</p>
  // <p>${receiptData.clientEmail || "-"}</p>
  // <p style="height: 20px"></p>
  // </td>
  // </tr>
  // </table>
  // </td>

  // <td class="stack-column" width="50%" style="padding-left:10px;vertical-align:top;">
  // <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr>
  // <td style="padding:16px;">
  // <h3 style="margin:0 0 10px;color:#1e3a8a;">Qwik IT Services</h3>
  // <p><strong>Head Office:</strong> ${receiptData.companyHeadOffice}</p>
  // <p><strong>Bangladesh Office:</strong> ${receiptData.companyBangladeshOffice}</p>
  // <p><strong>Phone:</strong> ${receiptData.companyPhoneBD}, ${receiptData.companyPhoneCanada}</p>
  // <p><strong>Support:</strong> ${receiptData.companyEmail}</p>
  // <p><strong>Billing:</strong> billing@qwikit.ca</p>
  // </td>
  // </tr>
  // </table>
  // </td>

  // </tr>
  // </table>

  // <!-- TABLE -->
  // <table width="100%" style="margin-top:20px;border-collapse:collapse;">
  // <tr style="background:#1e3a8a;color:white;">
  // <th style="padding:10px;text-align:left;">Description</th>
  // <th style="padding:10px;text-align:left;">Details</th>
  // </tr>

  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Project</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;">${project?.name || "-"}</td>
  // </tr>

  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Amount</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;">${formatCurrency(receiptData.totalAmount)}</td>
  // </tr>

  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Received Amount</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${formatCurrency(receiptData.newReceivedAmount)}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Received Amount</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${formatCurrency(receiptData.totalReceivedAmount)}</td>
  // </tr>


  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Remaining Amount</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;color:#dc2626;">${formatCurrency(receiptData.remainingAmount)}</td>
  // </tr>

  // <tr>
  // <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Payment Method</strong></td>
  // <td style="padding:10px;border-bottom:1px solid #eee;">${receiptData.paymentMethod}</td>
  // </tr>

  // </table>

  // <!-- SUMMARY -->
  // <table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr>
  // <td style="padding:10px;">Total Amount</td>
  // <td align="right" style="padding:10px;">${formatCurrency(receiptData.totalAmount)}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;">Received Amount</td>
  // <td align="right" style="padding:10px;color:#16a34a;">${formatCurrency(receiptData.newReceivedAmount)}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;">Total Received Amount</td>
  // <td align="right" style="padding:10px;color:#16a34a;">${formatCurrency(receiptData.totalReceivedAmount)}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;">Remaining Amount</td>
  // <td align="right" style="padding:10px;color:#dc2626;">${formatCurrency(receiptData.remainingAmount)}</td>
  // </tr>
  // </table>

  // <!-- STATUS -->
  // <table width="100%" style="margin-top:20px;text-align:center;">
  // <tr>
  // <td style="padding:16px;
  // background:${receiptData.paymentStatus === "PAID IN FULL" ? '#ecfdf5' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#fffbeb' : '#fef2f2'};
  // border-left:5px solid ${receiptData.paymentStatus === "PAID IN FULL" ? '#16a34a' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#f97316' : '#dc2626'};">
  // <p>Payment Status</p>
  // <h2 style="margin:10px 0; color:${receiptData.paymentStatus === "PAID IN FULL" ? '#16a34a' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#f97316' : '#dc2626'}">
  // ${receiptData.paymentStatus} 
  // </h2>
  // ${receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? `<p style="margin:8px 0 0 0; font-size:14px;">${formatCurrency(receiptData.remainingAmount)} Remaining</p>` : ''}
  // </td>
  // </tr>
  // </table>

  // </td>
  // </tr>

  // <!-- FOOTER -->
  // <tr>
  // <td style="text-align:center;padding:20px;background:#f3f4f6;">
  // <p>Thank you for your payment!</p>
  // <p>We appreciate your trust in Qwik IT Services</p>
  // </td>
  // </tr>

  // </table>

  // </td>
  // </tr>
  // </table>

  // </body>
  // </html>
  // `;
  //   };

  // Generate email HTML for money receipt
  const generateEmailHTML = () => {
    const useCurrency = receiptData.currency || "BDT";

    const getFormatCurrency = (amount) => {
      const formattedAmount = Math.round(amount).toLocaleString();
      switch (useCurrency) {
        case "USD": return `USD ${formattedAmount}`;
        case "CAD": return `CAD ${formattedAmount}`;
        case "EURO": return `EURO ${formattedAmount}`;
        default: return `BDT ${formattedAmount}`;
      }
    };

    return `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Money Receipt</title>

<style>
@media only screen and (max-width:600px){
  .stack-column{
    display:block !important;
    width:100% !important;
    padding:0 !important;
    margin-bottom:8px !important;
  }
  .stack-center{
    display:block !important;
    width:100% !important;
    text-align:center !important;
    padding:0 !important;
    margin-bottom:10px;
  }
  .stack-left{
    display:block !important;
    width:100% !important;
    text-align:left !important;
    padding-top:10px !important;
  }
}
</style>
</head>

<body style="margin:0;padding:0;background:#eef2f7;font-family:Arial,sans-serif;">

<table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
</td>
<td align="center">

<!-- MAIN -->
<table width="100%" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

<!-- HEADER -->
<tr>
<td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">

<table width="100%">
<tr>

<!-- LOGO -->
<td class="stack-center" width="80" align="center">
  <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
       width="60"
       style="display:block;margin:0 auto;">
</td>

<!-- TITLE -->
<td class="stack-center">
  <h1 style="margin:0;font-size:24px;">MONEY RECEIPT</h1>
  <p style="margin:3px 0;font-size:12px;">Qwik IT Services</p>
</td>

<!-- RIGHT INFO -->
<td class="stack-left" align="right" style="font-size:12px;">
  <p><strong>Receipt No:</strong> ${receiptData.receiptNo}</p>
  <p><strong>Date:</strong> ${formatDate(receiptData.receiptDate)}</p>
</td>

</tr>
</table>

</td>
</tr>

<!-- CONTENT -->
<tr>
<td style="padding:20px;">

<!-- INFO GRID -->
<table width="100%">
<tr>

<td class="stack-column" width="50%" style="padding-right:10px;vertical-align:top;">
<table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:16px;">
<h3 style="margin:0 0 10px;color:#1e3a8a;">Received From</h3>
<p><strong>${receiptData.clientName || "-"}</strong></p>
<p>${receiptData.clientAddress || "-"}</p>
<p>${receiptData.clientPhone || "-"}</p>
<p>${receiptData.clientEmail || "-"}</p>
<p style="height: 20px"></p>
</td>
</tr>
</table>
</td>

<td class="stack-column" width="50%" style="padding-left:10px;vertical-align:top;">
<table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:16px;">
<h3 style="margin:0 0 10px;color:#1e3a8a;">Qwik IT Services</h3>
<p><strong>Head Office:</strong> ${receiptData.companyHeadOffice}</p>
<p><strong>Bangladesh Office:</strong> ${receiptData.companyBangladeshOffice}</p>
<p><strong>Phone:</strong> ${receiptData.companyPhoneBD}, ${receiptData.companyPhoneCanada}</p>
<p><strong>Support:</strong> ${receiptData.companyEmail}</p>
<p><strong>Billing:</strong> billing@qwikit.ca</p>
</td>
</tr>
</table>
</td>

</tr>
</table>

<!-- TABLE -->
<table width="100%" style="margin-top:20px;border-collapse:collapse;">
<tr style="background:#1e3a8a;color:white;">
<th style="padding:10px;text-align:left;">Description</th>
<th style="padding:10px;text-align:left;">Details</th>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Project</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;">${project?.name || "-"}</td>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Amount</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;">${getFormatCurrency(receiptData.totalAmount)}</td>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>New Received Amount</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${getFormatCurrency(receiptData.newReceivedAmount)}</td>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Received Amount</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${getFormatCurrency(receiptData.totalReceivedAmount)}</td>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Remaining Amount</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;color:#dc2626;">${getFormatCurrency(receiptData.remainingAmount)}</td>
</tr>

<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Payment Method</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;">${receiptData.paymentMethod}</td>
</tr>

</table>

<!-- SUMMARY -->
<table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:10px;">Total Amount</td>
<td align="right" style="padding:10px;">${getFormatCurrency(receiptData.totalAmount)}</td>
</tr>
<tr>
<td style="padding:10px;">New Received Amount</td>
<td align="right" style="padding:10px;color:#16a34a;">${getFormatCurrency(receiptData.newReceivedAmount)}</td>
</tr>
<tr>
<td style="padding:10px;">Total Received Amount</td>
<td align="right" style="padding:10px;color:#16a34a;">${getFormatCurrency(receiptData.totalReceivedAmount)}</td>
</tr>
<tr>
<td style="padding:10px;">Remaining Amount</td>
<td align="right" style="padding:10px;color:#dc2626;">${getFormatCurrency(receiptData.remainingAmount)}</td>
</tr>
</table>

<!-- STATUS -->
<table width="100%" style="margin-top:20px;text-align:center;">
<tr>
<td style="padding:16px;
background:${receiptData.paymentStatus === "PAID IN FULL" ? '#ecfdf5' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#fffbeb' : '#fef2f2'};
border-left:5px solid ${receiptData.paymentStatus === "PAID IN FULL" ? '#16a34a' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#f97316' : '#dc2626'};">
<p>Payment Status</p>
<h2 style="margin:10px 0; color:${receiptData.paymentStatus === "PAID IN FULL" ? '#16a34a' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#f97316' : '#dc2626'}">
${receiptData.paymentStatus} 
</h2>
${receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? `<p style="margin:8px 0 0 0; font-size:14px;">${getFormatCurrency(receiptData.remainingAmount)} Remaining</p>` : ''}
</td>
</tr>
</table>

</td>
</tr>

<!-- FOOTER -->
<tr>
<td style="text-align:center;padding:20px;background:#f3f4f6;">
<p>Thank you for your payment!</p>
<p>We appreciate your trust in Qwik IT Services</p>
</td>
</tr>

</table>

</td>
</tr>
</table>

</body>
</html>
`;
  };


  // Function to send email only
  const sendEmailOnly = async (recipientEmail) => {
    const emailHTML = generateEmailHTML();

    const response = await fetch('https://resend-server.qwikit.ca/api/send-invoice', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: recipientEmail,
        subject: `Money Receipt #${receiptData.receiptNo} - Qwik IT Services`,
        html: emailHTML,
        invoiceNo: receiptData.receiptNo,
        clientName: receiptData.clientName,
      }),
    });

    return response.json();
  };

  // Function to save data to database
  const saveToDatabase = async (recipientEmail) => {
    const saveData = {
      project: parseInt(projectId),
      user: user?.id,
      receipt_no: receiptData.receiptNo,
      receipt_data: {
        companyHeadOffice: receiptData.companyHeadOffice,
        companyBangladeshOffice: receiptData.companyBangladeshOffice,
        companyPhoneBD: receiptData.companyPhoneBD,
        companyPhoneCanada: receiptData.companyPhoneCanada,
        companyEmail: receiptData.companyEmail,
        companyWebsite: receiptData.companyWebsite,
        clientName: receiptData.clientName,
        clientAddress: receiptData.clientAddress,
        clientPhone: receiptData.clientPhone,
        clientEmail: receiptData.clientEmail,
        receiptNo: receiptData.receiptNo,
        receiptDate: receiptData.receiptDate,
        totalAmount: receiptData.totalAmount,

        receivedAmount: receiptData.newReceivedAmount,     // ✅ Save NEW payment amount
        totalReceivedAmount: receiptData.totalReceivedAmount, // ✅ Save TOTAL received
        remainingAmount: receiptData.remainingAmount,


        // receivedAmount: receiptData.receivedAmount,
        // remainingAmount: receiptData.remainingAmount,
        paymentMethod: receiptData.paymentMethod,
        paymentStatus: receiptData.paymentStatus,
        currency: receiptData.currency,
        footerText: receiptData.footerText
      },
      project_info: {
        projectName: project?.name,
        projectBudget: project?.budget
      },
      payment_status: receiptData.paymentStatus,
      sent_to: recipientEmail,
      sent_at: new Date().toISOString(),
    };

    const result = await createMoneyReceipt(saveData).unwrap();
    return result;
  };

  // Function to update project payment array
  const updateProjectPayment = async () => {
    // Get current payments from project
    const currentPayments = project?.payment || [];

    // Calculate new payment ID
    const newPaymentId = currentPayments.length > 0
      ? Math.max(...currentPayments.map(p => p.id)) + 1
      : 1;

    // Create new payment object
    const newPayment = {
      id: newPaymentId,
      amount: receiptData.newReceivedAmount.toString(),
      date: new Date().toISOString().split("T")[0],
    };

    // Add new payment to existing payments
    const updatedPayments = [...currentPayments, newPayment];

    // Prepare update data
    const updateData = {
      payment: updatedPayments,
    };

    // Call update API
    const result = await updateProject({
      id: parseInt(projectId),
      formData: updateData,
    }).unwrap();

    return result;
  };

  // Handle Send Only
  const handleSendOnly = async () => {
    if (!receiptData.clientName) {
      toast.error("Please enter client name");
      return;
    }

    const recipientEmail = receiptData.clientEmail || client?.client_email;

    if (!recipientEmail) {
      toast.error("Client email is required to send receipt");
      return;
    }

    // if (receiptData.receivedAmount <= 0) {
    //   toast.error("Received amount must be greater than 0");
    //   return;
    // }

    if (receiptData.newReceivedAmount <= 0) {  // ✅ Changed to newReceivedAmount
      toast.error("Received amount must be greater than 0");
      return;
    }

    try {
      setIsSending(true);

      const emailData = await sendEmailOnly(recipientEmail);

      if (emailData.success) {
        toast.success(`Money Receipt #${receiptData.receiptNo} sent successfully to ${recipientEmail}`);
        setShowModal(false);
      } else {
        throw new Error(emailData.error || 'Failed to send receipt');
      }
    } catch (error) {
      console.error('Error sending receipt:', error);
      toast.error('Failed to send receipt. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  // Handle Save & Send
  // const handleSaveAndSend = async () => {
  //   if (!receiptData.clientName) {
  //     toast.error("Please enter client name");
  //     return;
  //   }

  //   const recipientEmail = receiptData.clientEmail || client?.client_email;

  //   if (!recipientEmail) {
  //     toast.error("Client email is required to send receipt");
  //     return;
  //   }

  //   if (receiptData.receivedAmount <= 0) {
  //     toast.error("Received amount must be greater than 0");
  //     return;
  //   }

  //   try {
  //     setIsSending(true);

  //     // Step 1: Send email
  //     const emailData = await sendEmailOnly(recipientEmail);

  //     if (!emailData.success) {
  //       throw new Error(emailData.error || 'Failed to send receipt');
  //     }

  //     // Step 2: Save to database
  //     const saveResult = await saveToDatabase(recipientEmail);

  //     if (saveResult.id) {
  //       toast.success(`Money Receipt #${receiptData.receiptNo} sent and saved! ID: ${saveResult.id}`);
  //       setShowModal(false);
  //     } else {
  //       toast.warning('Email sent but failed to save to database');
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //     toast.error('Failed to send receipt. Please try again.');
  //   } finally {
  //     setIsSending(false);
  //   }
  // };

  // Handle Save & Send
  const handleSaveAndSend = async () => {
    if (!receiptData.clientName) {
      toast.error("Please enter client name");
      return;
    }

    const recipientEmail = receiptData.clientEmail || client?.client_email;

    if (!recipientEmail) {
      toast.error("Client email is required to send receipt");
      return;
    }

    if (receiptData.newReceivedAmount <= 0) {  // ✅ Changed to newReceivedAmount
      toast.error("Received amount must be greater than 0");
      return;
    }

    try {
      setIsSending(true);

      // Step 1: Send email
      const emailData = await sendEmailOnly(recipientEmail);

      if (!emailData.success) {
        throw new Error(emailData.error || 'Failed to send receipt');
      }

      // Step 2: Update project payment array ✅ NEW
      await updateProjectPayment();
      toast.success("Project payment updated successfully");

      // Step 3: Save to database
      const saveResult = await saveToDatabase(recipientEmail);

      if (saveResult.id) {
        toast.success(`Money Receipt #${receiptData.receiptNo} sent and saved! ID: ${saveResult.id}`);
        setShowModal(false);
      } else {
        toast.warning('Email sent but failed to save to database');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to send receipt. Please try again.');
    } finally {
      setIsSending(false);
    }
  };


  // Open modal before sending
  const openSendModal = () => {
    if (!receiptData.clientName) {
      toast.error("Please enter client name");
      return;
    }

    const recipientEmail = receiptData.clientEmail || client?.client_email;

    if (!recipientEmail) {
      toast.error("Client email is required to send receipt");
      return;
    }

    // if (receiptData.receivedAmount <= 0) {
    //   toast.error("Received amount must be greater than 0");
    //   return;
    // }

    if (receiptData.newReceivedAmount <= 0) {  // ✅ Changed to newReceivedAmount
      toast.error("Received amount must be greater than 0");
      return;
    }


    setShowModal(true);
  };

  if (projectLoading || clientLoading) {
    return <DashboardLoader />;
  }

  if (!project) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="alert alert-danger">Project not found</div>
          <Link to="/all-projects" className="btn btn-primary">
            Back to Projects
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Money Receipt" breadcrumbItem={`Receipt for ${project?.name || "Project"}`} />

        {/* Action Buttons */}
        <div className="row mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <Link to="/all-projects" className="btn btn-secondary">
                <i className="fas fa-arrow-left me-1"></i> Back to Projects
              </Link>
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Processing..." : "Send Receipt to Client"}
              </button>
            </div>
          </div>
        </div>

        {/* Edit Form Section */}
        <div className="row mb-4 no-print">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3">Edit Money Receipt Details</h5>

                <div className="row">
                  {/* Client Section (Received From) */}
                  <div className="col-md-6">
                    <h6 className="mb-2 text-primary">Received From (Client Information)</h6>
                    <div className="mb-2">
                      <label className="form-label small">Client Name / Company Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.clientName}
                        onChange={(e) => handleReceiptChange("clientName", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Address</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.clientAddress}
                        onChange={(e) => handleReceiptChange("clientAddress", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Phone</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.clientPhone}
                        onChange={(e) => handleReceiptChange("clientPhone", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Email</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        value={receiptData.clientEmail}
                        onChange={(e) => handleReceiptChange("clientEmail", e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Receipt Details */}
                  <div className="col-md-6">
                    <h6 className="mb-2 text-primary">Receipt Details</h6>
                    <div className="mb-2">
                      <label className="form-label small">Receipt No</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.receiptNo}
                        onChange={(e) => handleReceiptChange("receiptNo", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Receipt Date</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={receiptData.receiptDate}
                        onChange={(e) => handleReceiptChange("receiptDate", e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <hr />

                {/* Payment Details */}
                {/* <h6 className="mb-2 text-primary">Payment Details</h6>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Total Amount (BDT)</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={receiptData.totalAmount}
                        onChange={(e) => handleReceiptChange("totalAmount", parseFloat(e.target.value) || 0)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Received Amount (BDT)</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={receiptData.receivedAmount}
                        onChange={(e) => handleReceiptChange("receivedAmount", parseFloat(e.target.value) || 0)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Remaining Amount (BDT)</label>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={formatCurrency(receiptData.remainingAmount)}
                        readOnly
                      />
                    </div>
                  </div>
                </div> */}

                {/* Payment Details */}
                <h6 className="mb-2 text-primary">Payment Details</h6>
                <div className="row">
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="form-label small">Total Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={receiptData.totalAmount}
                        onChange={(e) => handleReceiptChange("totalAmount", parseFloat(e.target.value) || 0)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="form-label small">Received Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={receiptData.newReceivedAmount}
                        onChange={(e) => handleReceiptChange("newReceivedAmount", parseFloat(e.target.value) || 0)}
                        placeholder="Enter today's payment"
                      />
                      <small className="text-muted">Enter amount client is paying now</small>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="form-label small">Total Received Amount</label>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={formatCurrency(receiptData.totalReceivedAmount)}
                        readOnly
                      />
                      <small className="text-muted">Previous + New payment</small>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="form-label small">Remaining Amount</label>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={formatCurrency(receiptData.remainingAmount)}
                        readOnly
                      />
                      <small className="text-muted">Auto-calculated remaining balance</small>
                    </div>
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Currency</label>
                      <select
                        className="form-control form-control-sm"
                        value={receiptData.currency}
                        onChange={(e) => handleReceiptChange("currency", e.target.value)}
                      >
                        <option value="BDT">BDT</option>
                        <option value="USD">USD</option>
                        <option value="CAD">CAD</option>
                        <option value="EURO">EURO</option>
                      </select>
                      <small className="text-muted">Select currency for this receipt</small>
                    </div>
                  </div>


                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Payment Method</label>
                      <select
                        className="form-control form-control-sm"
                        value={receiptData.paymentMethod}
                        onChange={(e) => handleReceiptChange("paymentMethod", e.target.value)}
                      >
                        {paymentMethods.map((method) => (
                          <option key={method} value={method}>{method}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small">Payment Status</label>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={receiptData.paymentStatus}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <hr />

                {/* Company Info */}
                <h6 className="mb-2 text-primary">Company Information (Qwik IT Services)</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-2">
                      <label className="form-label small">Head Office (Canada)</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.companyHeadOffice}
                        onChange={(e) => handleReceiptChange("companyHeadOffice", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Bangladesh Office</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.companyBangladeshOffice}
                        onChange={(e) => handleReceiptChange("companyBangladeshOffice", e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-2">
                      <label className="form-label small">Phone (BD)</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.companyPhoneBD}
                        onChange={(e) => handleReceiptChange("companyPhoneBD", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Phone (Canada)</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.companyPhoneCanada}
                        onChange={(e) => handleReceiptChange("companyPhoneCanada", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Company Email</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        value={receiptData.companyEmail}
                        onChange={(e) => handleReceiptChange("companyEmail", e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label small">Website</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={receiptData.companyWebsite}
                        onChange={(e) => handleReceiptChange("companyWebsite", e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <hr />

                {/* Footer */}
                <div className="mb-2">
                  <label className="form-label small">Footer Text</label>
                  <input
                    type="text"
                    className="form-control"
                    value={receiptData.footerText}
                    onChange={(e) => handleReceiptChange("footerText", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Receipt Preview */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3 text-center">Money Receipt Preview</h5>
                <div id="receipt-print" ref={receiptRef}>
                  <div className="receipt" style={{ maxWidth: "1000px", margin: "0 auto", background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 50px rgba(0,0,0,0.08)" }}>

                    {/* Header */}
                    <div style={{ background: "linear-gradient(135deg, #1e3a8a, #2563eb)", color: "white", padding: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        <div style={{ width: "50px", height: "50px", borderRadius: "10px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", border: "1px dashed rgba(255,255,255,0.6)" }}>
                          <img src={logoImg} alt="Qwik IT" style={{ width: "100%", height: "auto", maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                        </div>
                        <div>
                          <h1 style={{ margin: 0, fontSize: "24px", letterSpacing: "1px" }}>MONEY RECEIPT</h1>
                          <p style={{ margin: "3px 0", fontSize: "12px", opacity: 0.9 }}>Qwik IT Services</p>
                        </div>
                      </div>
                      <div>
                        <p style={{ margin: "4px 0", fontSize: "12px" }}><strong>Receipt No:</strong> {receiptData.receiptNo}</p>
                        <p style={{ margin: "4px 0", fontSize: "12px" }}><strong>Date:</strong> {formatDate(receiptData.receiptDate)}</p>
                      </div>
                    </div>

                    {/* Content */}
                    <div style={{ padding: "20px" }}>

                      {/* Info Grid */}
                      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: "20px" }}>
                        <div style={{ flex: 1, minWidth: "250px", background: "#f9fafb", border: "1px solid #e5e7eb", padding: "16px", borderRadius: "12px" }}>
                          <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a8a", fontSize: "16px" }}>Received From</h3>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>{receiptData.clientName || "-"}</strong></p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientAddress || "-"}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientPhone || "-"}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientEmail || "-"}</p>
                        </div>

                        <div style={{ flex: 1, minWidth: "250px", background: "#f9fafb", border: "1px solid #e5e7eb", padding: "16px", borderRadius: "12px" }}>
                          <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a8a", fontSize: "16px" }}>Qwik IT Services</h3>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Head Office:</strong> {receiptData.companyHeadOffice}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Bangladesh Office:</strong> {receiptData.companyBangladeshOffice}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Phone:</strong> {receiptData.companyPhoneBD}, {receiptData.companyPhoneCanada}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Support:</strong> {receiptData.companyEmail}</p>
                          <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Billing:</strong>
                            {/* {receiptData.companyWebsite} */}
                            billing@qwikit.ca
                          </p>
                        </div>
                      </div>

                      {/* Table */}
                      <div style={{ overflowX: "auto", marginBottom: "20px" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr style={{ background: "#1e3a8a", color: "white" }}>
                              <th style={{ padding: "10px 12px", textAlign: "left", fontSize: "13px" }}>Description</th>
                              <th style={{ padding: "10px 12px", textAlign: "left", fontSize: "13px" }}>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Project</strong></td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{project?.name || "-"}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Total Amount</strong></td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{formatCurrency(receiptData.totalAmount)}</td>
                            </tr>

                            {/* <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Received Amount</strong></td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.receivedAmount)}</td>
                            </tr> */}

                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>
                                <strong>New Received Amount</strong>
                              </td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#16a34a", fontWeight: "bold" }}>
                                {formatCurrency(receiptData.newReceivedAmount)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>
                                <strong>Total Received Amount</strong>
                              </td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#16a34a", fontWeight: "bold" }}>
                                {formatCurrency(receiptData.totalReceivedAmount)}
                              </td>
                            </tr>


                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Remaining Amount</strong></td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#dc2626", fontWeight: "bold" }}>{formatCurrency(receiptData.remainingAmount)}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Payment Method</strong></td>
                              <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{receiptData.paymentMethod}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Summary */}
                      <div style={{ background: "#f9fafb", padding: "16px", borderRadius: "12px", border: "1px solid #e5e7eb", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                          <span>Total Amount</span>
                          <span>{formatCurrency(receiptData.totalAmount)}</span>
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                          <span>Received Amount</span>
                          <span style={{ color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.receivedAmount)}</span>
                        </div> */}

                        <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                          <span>New Received Amount</span>
                          <span style={{ color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.newReceivedAmount)}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                          <span>Total Received Amount</span>
                          <span style={{ color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.totalReceivedAmount)}</span>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                          <span>Remaining Amount</span>
                          <span style={{ color: "#dc2626", fontWeight: "bold" }}>{formatCurrency(receiptData.remainingAmount)}</span>
                        </div>
                      </div>

                      {/* Status */}
                      {/* <div style={{
                        padding: "16px",
                        borderRadius: "12px",
                        background: receiptData.paymentStatus === "PAID IN FULL" ? "#ecfdf5" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#fffbeb" : "#fef2f2",
                        borderLeft: `4px solid ${receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626"}`,
                        textAlign: "center"
                      }}>
                        <p style={{ margin: 0 }}>Payment Status</p>
                        <h2 style={{ margin: "10px 0", fontSize: "20px", color: receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626" }}>
                          {receiptData.paymentStatus} {receiptData.paymentStatus === "PAID IN FULL" ? "✔" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "⚠" : "⏳"}
                        </h2>
                      </div> */}

                      <div style={{
                        padding: "16px",
                        borderRadius: "12px",
                        background: receiptData.paymentStatus === "PAID IN FULL" ? "#ecfdf5" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#fffbeb" : "#fef2f2",
                        borderLeft: `4px solid ${receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626"}`,
                        textAlign: "center"
                      }}>
                        <p style={{ margin: 0 }}>Payment Status</p>
                        <h2 style={{ margin: "10px 0", fontSize: "20px", color: receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626" }}>
                          {receiptData.paymentStatus}
                          {/* {receiptData.paymentStatus === "PAID IN FULL" ? "✔" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "⚠" : "⏳"} */}
                        </h2>

                        {/* Show remaining amount when status is PLEASE COMPLETE THE PENDING PAYMENT */}
                        {receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" && (
                          <p style={{
                            margin: "8px 0 0 0",
                            // fontSize: "16px",
                            // fontWeight: "bold",
                            // color: "#dc2626"
                          }}>
                            {formatCurrency(receiptData.remainingAmount)} Remaining
                          </p>
                        )}
                      </div>

                    </div>

                    {/* Footer */}
                    {/* <div style={{ textAlign: "center", padding: "20px", background: "#f3f4f6", fontSize: "12px", color: "#555" }}>
                      <p style={{ margin: 0, fontWeight: "bold", marginBottom: "8px" }}>{receiptData.footerText}</p>
                    </div> */}

                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        background: "#f3f4f6",
                        fontSize: "12px",
                        color: "#555",
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontWeight: "bold",
                          marginBottom: "8px",
                        }}
                      >
                        Thank you for your payment!
                      </p>
                      <p style={{ margin: 0 }}>
                        We appreciate your trust in Qwik IT Services
                      </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons Bottom */}
        <div className="row mt-4 mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Processing..." : "Send Receipt to Client"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Send Options */}
      {showModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "12px",
            width: "90%",
            maxWidth: "400px",
            padding: "24px",
            position: "relative",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          }}>
            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              ✕
            </button>

            <h3 style={{ marginTop: 0, marginBottom: "20px", color: "#1e3a8a" }}>
              Send Money Receipt
            </h3>

            <p style={{ marginBottom: "24px", color: "#555" }}>
              How would you like to send this receipt?
            </p>

            <button
              onClick={handleSendOnly}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginBottom: "12px",
                backgroundColor: "#2563eb",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: isSending ? "not-allowed" : "pointer",
                opacity: isSending ? 0.6 : 1,
              }}
            >
              {isSending ? "Sending..." : "Send Only"}
            </button>

            <button
              onClick={handleSaveAndSend}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#16a34a",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: isSending ? "not-allowed" : "pointer",
                opacity: isSending ? 0.6 : 1,
              }}
            >
              {isSending ? "Saving & Sending..." : "Save & Send"}
            </button>

            <button
              onClick={() => setShowModal(false)}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "12px",
                backgroundColor: "#f3f4f6",
                color: "#374151",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: isSending ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MoneyReceipt;

// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectUser } from "store/features/auth/authSlice";
// import { toast } from "sonner";
// import Breadcrumb from "components/Common/Breadcrumb";
// import DashboardLoader from "components/Loader/DashboardLoader";
// import {
//   useGetProjectByIdQuery,
//   useGetClientQuery,
// } from "store/features/client/clientManagementApi";
// import logoImg from "../../assets/images/logo-sm.png";

// const MoneyReceipt = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector(selectUser);
//   const receiptRef = useRef(null);

//   const { data: project, isLoading: projectLoading } = useGetProjectByIdQuery(projectId);
//   const { data: client, isLoading: clientLoading } = useGetClientQuery(project?.client, {
//     skip: !project?.client,
//   });

//   const [isSending, setIsSending] = useState(false);

//   // Editable receipt state
//   const [receiptData, setReceiptData] = useState({
//     // Company Info
//     companyHeadOffice: "950 Hillcrest Rd, Saint John, NB E2N2B2, Canada",
//     companyBangladeshOffice: "House-752, Road-8, Adabor, Dhaka",
//     companyPhoneBD: "+880 1636-131313",
//     companyPhoneCanada: "+1 (506) 899-3939",
//     companyEmail: "support@qwikit.ca",
//     companyWebsite: "www.qwikit.ca",

//     // Client Info (Received From)
//     clientName: "",
//     clientAddress: "",
//     clientPhone: "",
//     clientEmail: "",

//     // Receipt Details
//     receiptNo: "",
//     receiptDate: new Date().toISOString().split("T")[0],

//     // Payment Details
//     totalAmount: 0,
//     receivedAmount: 0,
//     remainingAmount: 0,
//     paymentMethod: "Bank Transfer",
//     paymentStatus: "PLEASE COMPLETE THE PENDING PAYMENT",

//     // Footer
//     footerText: "Thank you for your payment! We appreciate your trust in Qwik IT Services",
//   });

//   // Payment methods options
//   const paymentMethods = ["Bank Transfer", "bKash", "Nagad", "Stripe", "Cash"];

//   // Load project data into receipt
//   useEffect(() => {
//     if (project && client) {
//       // Calculate total from project budget
//       const projectBudget = parseFloat(project.budget) || 0;

//       // Calculate total received from payments
//       const totalReceived = (project.payment || []).reduce(
//         (sum, payment) => sum + (parseFloat(payment.amount) || 0),
//         0
//       );

//       const remainingAmount = projectBudget - totalReceived;

//       // Determine payment status
//       let paymentStatus = "PENDING";
//       if (totalReceived === 0) {
//         paymentStatus = "PENDING";
//       } else if (totalReceived >= projectBudget) {
//         paymentStatus = "PAID IN FULL";
//       } else {
//         paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
//       }

//       // Get client email from client data
//       const clientEmail = client.client_email || client.email || "";

//       // Set receipt data with client info
//       setReceiptData((prev) => ({
//         ...prev,
//         // Client Info
//         clientName: client.company_name || client.client_name || "",
//         clientAddress: client.address || "",
//         clientPhone: client.contact_number || "",
//         clientEmail: clientEmail,

//         // Receipt details
//         receiptNo: `QIT-REC-${project.id}-${Date.now().toString().slice(-6)}`,
//         receiptDate: new Date().toISOString().split("T")[0],

//         // Payment details
//         totalAmount: projectBudget,
//         receivedAmount: totalReceived,
//         remainingAmount: remainingAmount,
//         paymentStatus: paymentStatus,
//       }));
//     }
//   }, [project, client]);

//   // Update remaining amount when received amount changes
//   useEffect(() => {
//     const remaining = receiptData.totalAmount - receiptData.receivedAmount;
//     let paymentStatus = "PENDING";
//     if (receiptData.receivedAmount === 0) {
//       paymentStatus = "PENDING";
//     } else if (receiptData.receivedAmount >= receiptData.totalAmount) {
//       paymentStatus = "PAID IN FULL";
//     } else {
//       paymentStatus = "PLEASE COMPLETE THE PENDING PAYMENT";
//     }

//     setReceiptData((prev) => ({
//       ...prev,
//       remainingAmount: remaining,
//       paymentStatus: paymentStatus,
//     }));
//   }, [receiptData.receivedAmount, receiptData.totalAmount]);

//   // Format currency
//   const formatCurrency = (amount) => {
//     return `BDT ${Math.round(amount).toLocaleString()}`;
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
//   };

//   // Handle receipt field changes
//   const handleReceiptChange = (field, value) => {
//     setReceiptData((prev) => ({ ...prev, [field]: value }));
//   };

//   // Generate email HTML for money receipt
//   const generateEmailHTML = () => {
//     return `
// <!DOCTYPE html>
// <html>
// <head>
// <meta charset="UTF-8">
// <title>Money Receipt</title>

// <style>
// @media only screen and (max-width:600px){

//   .stack-column{
//     display:block !important;
//     width:100% !important;
//     padding:0 !important;
//   }

//   .stack-center{
//     display:block !important;
//     width:100% !important;
//     text-align:center !important;
//     padding:0 !important;
//     margin-bottom:10px;
//   }

//   .stack-left{
//     display:block !important;
//     width:100% !important;
//     text-align:left !important;
//     padding-top:10px !important;
//   }

// }
// </style>

// </head>

// <body style="margin:0;padding:0;background:#eef2f7;font-family:Arial,sans-serif;">

// <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
// <tr>
// <td align="center">

// <!-- MAIN -->
// <table width="100%" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

// <!-- HEADER -->
// <tr>
// <td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">

// <table width="100%">
// <tr>

// <!-- LOGO -->
// <td class="stack-center" width="80" align="center">
//   <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
//        width="60"
//        style="display:block;margin:0 auto;">
// </td>

// <!-- TITLE -->
// <td class="stack-center">
//   <h1 style="margin:0;font-size:24px;">MONEY RECEIPT</h1>
//   <p style="margin:3px 0;font-size:12px;">Qwik IT Services</p>
// </td>

// <!-- RIGHT INFO -->
// <td class="stack-left" align="right" style="font-size:12px;">
//   <p><strong>Receipt No:</strong> ${receiptData.receiptNo}</p>
//   <p><strong>Date:</strong> ${formatDate(receiptData.receiptDate)}</p>
// </td>

// </tr>
// </table>

// </td>
// </tr>

// <!-- CONTENT -->
// <tr>
// <td style="padding:20px;">

// <!-- INFO GRID -->
// <table width="100%">
// <tr>

// <td class="stack-column" width="50%" style="padding-right:10px;vertical-align:top;">
// <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
// <tr>
// <td style="padding:16px;">
// <h3 style="margin:0 0 10px;color:#1e3a8a;">Received From</h3>
// <p><strong>${receiptData.clientName || "-"}</strong></p>
// <p>${receiptData.clientAddress || "-"}</p>
// <p>${receiptData.clientPhone || "-"}</p>
// <p>${receiptData.clientEmail || "-"}</p>
// </td>
// </tr>
// </table>
// </td>

// <td class="stack-column" width="50%" style="padding-left:10px;vertical-align:top;">
// <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
// <tr>
// <td style="padding:16px;">
// <h3 style="margin:0 0 10px;color:#1e3a8a;">Qwik IT Services</h3>
// <p><strong>Head Office:</strong> ${receiptData.companyHeadOffice}</p>
// <p><strong>Bangladesh Office:</strong> ${receiptData.companyBangladeshOffice}</p>
// <p><strong>Phone:</strong> ${receiptData.companyPhoneBD}, ${receiptData.companyPhoneCanada}</p>
// <p><strong>Email:</strong> ${receiptData.companyEmail}</p>
// <p><strong>Web:</strong> ${receiptData.companyWebsite}</p>
// </td>
// </tr>
// </table>
// </td>

// </tr>
// </table>

// <!-- TABLE -->
// <table width="100%" style="margin-top:20px;border-collapse:collapse;">
// <tr style="background:#1e3a8a;color:white;">
// <th style="padding:10px;text-align:left;">Description</th>
// <th style="padding:10px;text-align:left;">Details</th>
// </tr>

// <tr>
// <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Project</strong></td>
// <td style="padding:10px;border-bottom:1px solid #eee;">${project?.name || "-"}</td>
// </tr>

// <tr>
// <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Amount</strong></td>
// <td style="padding:10px;border-bottom:1px solid #eee;">${formatCurrency(receiptData.totalAmount)}</td>
// </tr>

// <tr>
// <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Received Amount</strong></td>
// <td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${formatCurrency(receiptData.receivedAmount)}</td>
// </tr>

// <tr>
// <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Remaining Amount</strong></td>
// <td style="padding:10px;border-bottom:1px solid #eee;color:#dc2626;">${formatCurrency(receiptData.remainingAmount)}</td>
// </tr>

// <tr>
// <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Payment Method</strong></td>
// <td style="padding:10px;border-bottom:1px solid #eee;">${receiptData.paymentMethod}</td>
// </tr>

// </table>

// <!-- SUMMARY -->
// <table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
// <tr>
// <td style="padding:10px;">Total Amount</td>
// <td align="right" style="padding:10px;">${formatCurrency(receiptData.totalAmount)}</td>
// </tr>
// <tr>
// <td style="padding:10px;">Received Amount</td>
// <td align="right" style="padding:10px;color:#16a34a;">${formatCurrency(receiptData.receivedAmount)}</td>
// </tr>
// <tr>
// <td style="padding:10px;">Remaining Amount</td>
// <td align="right" style="padding:10px;color:#dc2626;">${formatCurrency(receiptData.remainingAmount)}</td>
// </tr>
// </table>

// <!-- STATUS -->
// <table width="100%" style="margin-top:20px;text-align:center;">
// <tr>
// <td style="padding:16px;
// background:${receiptData.paymentStatus === "PAID IN FULL" ? '#ecfdf5' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#fffbeb' : '#fef2f2'};
// border-left:5px solid ${receiptData.paymentStatus === "PAID IN FULL" ? '#16a34a' : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? '#f97316' : '#dc2626'};">
// <p>Payment Status</p>
// <h2 style="margin:10px 0; color:"#dc2626">
// ${receiptData.paymentStatus}
// </h2>
// </td>
// </tr>
// </table>

// <div style="margin-top:20px;text-align:center;font-size:13px;">
// <p>Best regards,</p>
// <p><strong>Qwik IT Services</strong></p>
// <p>+1 (506) 899-3939</p>
// <p>www.qwikit.ca</p>
// </div>

// </td>
// </tr>

// <!-- FOOTER -->
// <tr>
// <td style="text-align:center;padding:20px;background:#f3f4f6;">
// <p>Thank you for your payment!</p>
// <p>We appreciate your trust in Qwik IT Services</p>
// </td>
// </tr>

// </table>

// </td>
// </tr>
// </table>

// </body>
// </html>
// `;
//   };

//   // Send receipt via email
//   const handleSendReceipt = async () => {
//     if (!receiptData.clientName) {
//       toast.error("Please enter client name");
//       return;
//     }

//     const recipientEmail = receiptData.clientEmail || client?.client_email;

//     if (!recipientEmail) {
//       toast.error("Client email is required to send receipt");
//       return;
//     }

//     if (receiptData.receivedAmount <= 0) {
//       toast.error("Received amount must be greater than 0");
//       return;
//     }

//     try {
//       setIsSending(true);
//       const emailHTML = generateEmailHTML();

//       const response = await fetch('http://localhost:5000/api/send-invoice', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           to: recipientEmail,
//           subject: `Money Receipt #${receiptData.receiptNo} - Qwik IT Services`,
//           html: emailHTML,
//           invoiceNo: receiptData.receiptNo,
//           clientName: receiptData.clientName,
//         }),
//       });

//       const data = await response.json();

//       if (data.success) {
//         toast.success(`Money Receipt #${receiptData.receiptNo} sent successfully to ${recipientEmail}`);
//       } else {
//         throw new Error(data.error || 'Failed to send receipt');
//       }
//     } catch (error) {
//       console.error('Error sending receipt:', error);
//       toast.error('Failed to send receipt. Please make sure server is running on port 5000');
//     } finally {
//       setIsSending(false);
//     }
//   };

//   if (projectLoading || clientLoading) {
//     return <DashboardLoader />;
//   }

//   if (!project) {
//     return (
//       <div className="page-content">
//         <div className="container-fluid">
//           <div className="alert alert-danger">Project not found</div>
//           <Link to="/all-projects" className="btn btn-primary">
//             Back to Projects
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="page-content">
//       <div className="container-fluid">
//         <Breadcrumb title="Money Receipt" breadcrumbItem={`Receipt for ${project?.name || "Project"}`} />

//         {/* Action Buttons */}
//         <div className="row mb-4 no-print">
//           <div className="col-12">
//             <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//               <Link to="/all-projects" className="btn btn-secondary">
//                 <i className="fas fa-arrow-left me-1"></i> Back to Projects
//               </Link>
//               <button
//                 type="button"
//                 className="btn btn-success"
//                 onClick={handleSendReceipt}
//                 disabled={isSending}
//               >
//                 <i className="fas fa-envelope me-1"></i>
//                 {isSending ? "Sending..." : "Send Receipt to Client"}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Edit Form Section */}
//         <div className="row mb-4 no-print">
//           <div className="col-12">
//             <div className="card">
//               <div className="card-body">
//                 <h5 className="card-title mb-3">Edit Money Receipt Details</h5>

//                 <div className="row">
//                   {/* Client Section (Received From) */}
//                   <div className="col-md-6">
//                     <h6 className="mb-2 text-primary">Received From (Client Information)</h6>
//                     <div className="mb-2">
//                       <label className="form-label small">Client Name / Company Name</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.clientName}
//                         onChange={(e) => handleReceiptChange("clientName", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Address</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.clientAddress}
//                         onChange={(e) => handleReceiptChange("clientAddress", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Phone</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.clientPhone}
//                         onChange={(e) => handleReceiptChange("clientPhone", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Email</label>
//                       <input
//                         type="email"
//                         className="form-control form-control-sm"
//                         value={receiptData.clientEmail}
//                         onChange={(e) => handleReceiptChange("clientEmail", e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   {/* Receipt Details */}
//                   <div className="col-md-6">
//                     <h6 className="mb-2 text-primary">Receipt Details</h6>
//                     <div className="mb-2">
//                       <label className="form-label small">Receipt No</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.receiptNo}
//                         onChange={(e) => handleReceiptChange("receiptNo", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Receipt Date</label>
//                       <input
//                         type="date"
//                         className="form-control form-control-sm"
//                         value={receiptData.receiptDate}
//                         onChange={(e) => handleReceiptChange("receiptDate", e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <hr />

//                 {/* Payment Details */}
//                 <h6 className="mb-2 text-primary">Payment Details</h6>
//                 <div className="row">
//                   <div className="col-md-4">
//                     <div className="mb-2">
//                       <label className="form-label small">Total Amount (BDT)</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         value={receiptData.totalAmount}
//                         onChange={(e) => handleReceiptChange("totalAmount", parseFloat(e.target.value) || 0)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="mb-2">
//                       <label className="form-label small">Received Amount (BDT)</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         value={receiptData.receivedAmount}
//                         onChange={(e) => handleReceiptChange("receivedAmount", parseFloat(e.target.value) || 0)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="mb-2">
//                       <label className="form-label small">Remaining Amount (BDT)</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm bg-light"
//                         value={formatCurrency(receiptData.remainingAmount)}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="mb-2">
//                       <label className="form-label small">Payment Method</label>
//                       <select
//                         className="form-control form-control-sm"
//                         value={receiptData.paymentMethod}
//                         onChange={(e) => handleReceiptChange("paymentMethod", e.target.value)}
//                       >
//                         {paymentMethods.map((method) => (
//                           <option key={method} value={method}>{method}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="mb-2">
//                       <label className="form-label small">Payment Status</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm bg-light"
//                         value={receiptData.paymentStatus}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <hr />

//                 {/* Company Info */}
//                 <h6 className="mb-2 text-primary">Company Information (Qwik IT Services)</h6>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="mb-2">
//                       <label className="form-label small">Head Office (Canada)</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyHeadOffice}
//                         onChange={(e) => handleReceiptChange("companyHeadOffice", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Bangladesh Office</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyBangladeshOffice}
//                         onChange={(e) => handleReceiptChange("companyBangladeshOffice", e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="mb-2">
//                       <label className="form-label small">Phone (BD)</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyPhoneBD}
//                         onChange={(e) => handleReceiptChange("companyPhoneBD", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Phone (Canada)</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyPhoneCanada}
//                         onChange={(e) => handleReceiptChange("companyPhoneCanada", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Company Email</label>
//                       <input
//                         type="email"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyEmail}
//                         onChange={(e) => handleReceiptChange("companyEmail", e.target.value)}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label className="form-label small">Website</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         value={receiptData.companyWebsite}
//                         onChange={(e) => handleReceiptChange("companyWebsite", e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <hr />

//                 {/* Footer */}
//                 <div className="mb-2">
//                   <label className="form-label small">Footer Text</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={receiptData.footerText}
//                     onChange={(e) => handleReceiptChange("footerText", e.target.value)}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Receipt Preview */}
//         <div className="row">
//           <div className="col-12">
//             <div className="card">
//               <div className="card-body">
//                 <h5 className="card-title mb-3 text-center">Money Receipt Preview</h5>
//                 <div id="receipt-print" ref={receiptRef}>
//                   <div className="receipt" style={{ maxWidth: "1000px", margin: "0 auto", background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 50px rgba(0,0,0,0.08)" }}>

//                     {/* Header */}
//                     <div style={{ background: "linear-gradient(135deg, #1e3a8a, #2563eb)", color: "white", padding: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
//                         <div style={{ width: "50px", height: "50px", borderRadius: "10px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", border: "1px dashed rgba(255,255,255,0.6)" }}>
//                           <img src={logoImg} alt="Qwik IT" style={{ width: "100%", height: "auto", maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
//                         </div>
//                         <div>
//                           <h1 style={{ margin: 0, fontSize: "24px", letterSpacing: "1px" }}>MONEY RECEIPT</h1>
//                           <p style={{ margin: "3px 0", fontSize: "12px", opacity: 0.9 }}>Qwik IT Services</p>
//                         </div>
//                       </div>
//                       <div>
//                         <p style={{ margin: "4px 0", fontSize: "12px" }}><strong>Receipt No:</strong> {receiptData.receiptNo}</p>
//                         <p style={{ margin: "4px 0", fontSize: "12px" }}><strong>Date:</strong> {formatDate(receiptData.receiptDate)}</p>
//                       </div>
//                     </div>

//                     {/* Content */}
//                     <div style={{ padding: "20px" }}>

//                       {/* Info Grid */}
//                       <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: "20px" }}>
//                         <div style={{ flex: 1, minWidth: "250px", background: "#f9fafb", border: "1px solid #e5e7eb", padding: "16px", borderRadius: "12px" }}>
//                           <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a8a", fontSize: "16px" }}>Received From</h3>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>{receiptData.clientName || "-"}</strong></p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientAddress || "-"}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientPhone || "-"}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}>{receiptData.clientEmail || "-"}</p>
//                         </div>

//                         <div style={{ flex: 1, minWidth: "250px", background: "#f9fafb", border: "1px solid #e5e7eb", padding: "16px", borderRadius: "12px" }}>
//                           <h3 style={{ marginTop: 0, marginBottom: "12px", color: "#1e3a8a", fontSize: "16px" }}>Qwik IT Services</h3>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Head Office:</strong> {receiptData.companyHeadOffice}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Bangladesh Office:</strong> {receiptData.companyBangladeshOffice}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Phone:</strong> {receiptData.companyPhoneBD}, {receiptData.companyPhoneCanada}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Email:</strong> {receiptData.companyEmail}</p>
//                           <p style={{ margin: "6px 0", fontSize: "13px" }}><strong>Web:</strong> {receiptData.companyWebsite}</p>
//                         </div>
//                       </div>

//                       {/* Table */}
//                       <div style={{ overflowX: "auto", marginBottom: "20px" }}>
//                         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                           <thead>
//                             <tr style={{ background: "#1e3a8a", color: "white" }}>
//                               <th style={{ padding: "10px 12px", textAlign: "left", fontSize: "13px" }}>Description</th>
//                               <th style={{ padding: "10px 12px", textAlign: "left", fontSize: "13px" }}>Details</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             <tr>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Project</strong></td>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{project?.name || "-"}</td>
//                             </tr>
//                             <tr>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Total Amount</strong></td>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{formatCurrency(receiptData.totalAmount)}</td>
//                             </tr>
//                             <tr>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Received Amount</strong></td>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.receivedAmount)}</td>
//                             </tr>
//                             <tr>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Remaining Amount</strong></td>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px", color: "#dc2626", fontWeight: "bold" }}>{formatCurrency(receiptData.remainingAmount)}</td>
//                             </tr>
//                             <tr>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}><strong>Payment Method</strong></td>
//                               <td style={{ padding: "10px 12px", borderBottom: "1px solid #eee", fontSize: "13px" }}>{receiptData.paymentMethod}</td>
//                             </tr>
//                           </tbody>
//                         </table>
//                       </div>

//                       {/* Summary */}
//                       <div style={{ background: "#f9fafb", padding: "16px", borderRadius: "12px", border: "1px solid #e5e7eb", marginBottom: "20px" }}>
//                         <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
//                           <span>Total Amount</span>
//                           <span>{formatCurrency(receiptData.totalAmount)}</span>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
//                           <span>Received Amount</span>
//                           <span style={{ color: "#16a34a", fontWeight: "bold" }}>{formatCurrency(receiptData.receivedAmount)}</span>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
//                           <span>Remaining Amount</span>
//                           <span style={{ color: "#dc2626", fontWeight: "bold" }}>{formatCurrency(receiptData.remainingAmount)}</span>
//                         </div>
//                       </div>

//                       {/* Status */}
//                       <div style={{
//                         padding: "16px",
//                         borderRadius: "12px",
//                         background: receiptData.paymentStatus === "PAID IN FULL" ? "#ecfdf5" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#fffbeb" : "#fef2f2",
//                         borderLeft: `4px solid ${receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626"}`,
//                         textAlign: "center"
//                       }}>
//                         <p style={{ margin: 0 }}>Payment Status</p>
//                         <h2 style={{ margin: "10px 0", fontSize: "20px", color: receiptData.paymentStatus === "PAID IN FULL" ? "#16a34a" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "#f97316" : "#dc2626" }}>
//                           {receiptData.paymentStatus} {receiptData.paymentStatus === "PAID IN FULL" ? "✔" : receiptData.paymentStatus === "PLEASE COMPLETE THE PENDING PAYMENT" ? "⚠" : "⏳"}
//                         </h2>
//                       </div>

//                     </div>

//                     {/* Footer */}
//                     <div style={{ textAlign: "center", padding: "20px", background: "#f3f4f6", fontSize: "12px", color: "#555" }}>
//                       <p style={{ margin: 0, fontWeight: "bold", marginBottom: "8px" }}>{receiptData.footerText}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Action Buttons Bottom */}
//         <div className="row mt-4 mb-4 no-print">
//           <div className="col-12">
//             <div className="d-flex justify-content-center">
//               <button
//                 type="button"
//                 className="btn btn-success"
//                 onClick={handleSendReceipt}
//                 disabled={isSending}
//               >
//                 <i className="fas fa-envelope me-1"></i>
//                 {isSending ? "Sending..." : "Send Receipt to Client"}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MoneyReceipt;